const landingTypesList = [
  '/',
  '/fullPrice',
  '/alfa_bravo',
  '/trial_exp',
  '/trial_chp',
  '/alfa',
  '/alfa2',
  '/trial_v2',
  '/trial_v2eur',
  '/intro_offer',
  '/bravo',
  '/trivia',
];

export default landingTypesList;